import { render, staticRenderFns } from "./MXTable.vue?vue&type=template&id=19ed90c6&scoped=true"
import script from "./MXTable.vue?vue&type=script&lang=js"
export * from "./MXTable.vue?vue&type=script&lang=js"
import "./MXTable.vue?vue&type=style&index=0&id=19ed90c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed90c6",
  null
  
)

export default component.exports